import Phaser from 'phaser';
import { PALETTE } from '../config';

export interface PanelOptions {
  radius?: number;
  fill?: number;
  fillAlpha?: number;
  stroke?: number;
  strokeAlpha?: number;
  shadow?: boolean;
}

/**
 * Consistent rounded "glass card" used behind text blocks across screens, so every
 * panel shares the same look. Returns the Graphics (centred at x,y) for further depth
 * tweaks. Cheap, drawn once.
 */
export function drawPanel(scene: Phaser.Scene, x: number, y: number, w: number, h: number, opts: PanelOptions = {}): Phaser.GameObjects.Graphics {
  const r = opts.radius ?? 22;
  const fill = opts.fill ?? PALETTE.bgTop;
  const fillAlpha = opts.fillAlpha ?? 0.82;
  const g = scene.add.graphics();
  if (opts.shadow !== false) g.fillStyle(0x000000, 0.35).fillRoundedRect(x - w / 2, y - h / 2 + 8, w, h, r);
  g.fillStyle(fill, fillAlpha).fillRoundedRect(x - w / 2, y - h / 2, w, h, r);
  g.lineStyle(2, opts.stroke ?? PALETTE.cadence, opts.strokeAlpha ?? 0.35).strokeRoundedRect(x - w / 2, y - h / 2, w, h, r);
  return g;
}
